import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FieldSet from '../../fieldset/FieldSet';
import VerticalLabelList from '../../label/VerticalLabelList';
import Grid from '../../grid/Grid';

class SDKPayment extends React.Component {
  constructor(props) {
    super(props);

    this.keyExclusions = [ 'mongoId', 'className', ];
  }

  formatList(items = []) {
    return items.map((item) => {
      const ref = { ...item, };
      ref.label = item.name ? item.name : item.label;
      ref.value = item.value;
      return ref;
    });
  }

  render() {
    const { payment, } = this.props;
    const { paymentMetadata = [], paymentItemization = [], } = payment;

    const itemsToShow = VerticalLabelList.toList({
      Label: payment.label,
      Description: payment.desription,
      'Customer Id': payment.customerId,
      'Customer Email': payment.customerEmail,
      'Service Offering Id': payment.serviceOfferingId,
      'External Id': payment.externalId,
      Amount: payment.total.amount,
      'Transaction Id': payment.transactionId,
      'Line Item Id': payment.lineItemId,
      'Transaction TimeStamp': payment.transactionTimestamp,
      'Is a Refund': payment.isRefund ? payment.isRefund : 'false',
      'Is ACH Failure': payment.isAchFailure ? payment.isAchFailure : 'false',
      Id: payment.id,
    });

    const paymentMetadataModel = Grid.toModelFromList(paymentMetadata, {
      headerFormatter: value => _.startCase(value.header),
    });
    const itemizationModel = Grid.toModelFromList(paymentItemization, {
      headerFormatter: value => _.startCase(value.header),
    });

    return (
      <>
        <FieldSet title="Payment Summary" style={{ height: '100%', fontSize: '20px', }}>
          <VerticalLabelList items={itemsToShow} exclusions={this.keyExclusions} />
        </FieldSet>
        <FieldSet title="Payment Metadata">
          <Grid
            headers={paymentMetadataModel.headers}
            rows={paymentMetadataModel.format(this.formatList(paymentMetadata))}
          />
        </FieldSet>
        <FieldSet title="Payment Itemization">
          <Grid
            headers={itemizationModel.headers}
            rows={itemizationModel.format(this.formatList(paymentItemization))}
          />
        </FieldSet>
      </>
    );
  }
}

SDKPayment.propTypes = {
  payment: PropTypes.instanceOf(Object).isRequired,
};

export default SDKPayment;
